import React, { useState, useEffect } from "react";
import Card from "@mui/joy/Card";
import CardCover from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";

export default function VideoIdentification(props) {
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    const { individualId } = props;
    setVideoUrl(individualId);
  }, [props]);

  return (
    <Card component="li" sx={{ flexGrow: 1 }}>
      <CardContent>
        <Typography
          level="h6"
          fontWeight="lg"
          textColor="#fff"
          mt={{ xs: 12, sm: 18 }}
        >
          Video Identification
        </Typography>
      </CardContent>
      <CardCover>
        <video
          autoPlay
          // loop
          controls
          muted
          poster="https://assets.codepen.io/6093409/river.jpg"
        >
          <source src={videoUrl} />
        </video>
      </CardCover>
    </Card>
  );
}
